export const Svgback: string = '%3Csvg%20xmlns%3D"http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg"%20width%3D"10.844"%20height%3D"17.193"%3E%3Cpath%20fill%3D"%23fff"%20fill-rule%3D"evenodd"%20d%3D"M8.7%200%200%208.705l8.488%208.488%202.14-2.14-6.349-6.348%206.565-6.562Z"%2F%3E%3C%2Fsvg%3E';
export default Svgback;
